!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/warning"] = r() : (e.wp = e.wp || {}, e.wp.warning = r());
}(self, function () {
  return function () {
    "use strict";

    var e = {
      7: function _(e, r) {
        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.logged = void 0;
        var o = new Set();
        r.logged = o;
      }
    },
        r = {};

    function __webpack_require__(o) {
      var t = r[o];
      if (void 0 !== t) return t.exports;
      var n = r[o] = {
        exports: {}
      };
      return e[o](n, n.exports, __webpack_require__), n.exports;
    }

    var o = {};
    return function () {
      var e = o;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = function warning(e) {
        if (!function isDev() {
          return "undefined" != typeof process && process.env && !1;
        }()) return;
        if (r.logged.has(e)) return;
        console.warn(e);

        try {
          throw Error(e);
        } catch (e) {}

        r.logged.add(e);
      };

      var r = __webpack_require__(7);
    }(), o;
  }();
});